import { render } from "./IconCircle.vue?vue&type=template&id=09d63422&ts=true"
import script from "./IconCircle.vue?vue&type=script&lang=ts"
export * from "./IconCircle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__